import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;

  a {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    color: ${({ theme }) => theme.colors.primary.main};

    img {
      width: 28px;
      margin-top: -10px;
    }

    &:hover {
      transition: 0.7s;
      color: ${({ theme }) => theme.colors.primary.light};
    }
  }
`;
